import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HomePageConductorLink() {
  const { t } = useTranslation('public');
  return (
    <Link className="homepage-conductor-link" to="/manage">
      <span className="homepage-conductor-hotspot" aria-hidden="true" />
      <span className="homepage-conductor-bubble">
        {t('homepageSignIn')}
        <span aria-hidden="true"> →</span>
      </span>
    </Link>
  );
}

export default HomePageConductorLink;
